// extracted by mini-css-extract-plugin
export default {"card":"stayle_card__Dg4wP","card__heading":"stayle_card__heading__V9ei1"};